module.exports = __webpack_public_path__ + "img/all-inclusive-dining.1c4ecc7e.png";